import React from 'react'

import logo from '../assets/images/logo.svg';

const Header = (props) => (
    <header id="header" className="alt">
        <span className="logo"><img src={logo} alt="" /></span>
        <h1>Asgaard Software</h1>
        <p>Software development in Birmingham.</p>
        <p><a href='news'>Technology News</a></p>
    </header>
)

export default Header
